import Layout from '@/layout'

const productRouter = {
    path: '/product',
    component: Layout,
    children: [
        {
            path: 'classify',
            name: 'ProductClassify',
            component: () => import('@/views/product/classify/index')
        },
        {
            path: 'detail',
            name: 'ProductDetail',
            component: () => import('@/views/product/detail/index')
        },
        {
            path: 'list',
            name: 'ProductList',
            component: () => import('@/views/product/list/index'),
            meta: {
                title: '产品搜索'
            }
        }
    ]
}

export default productRouter